import { PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class AutoAdaptAccessoriesSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'AutoAdaptAccessoriesSystem', ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID);
        this.coreApi = coreApi;
        this.dragAffectingAccessories = false;
        this.boxVariant = undefined;
        this.matVariant = undefined;
        this.skubbVariant = undefined;
        this.oldDraggedEntity = {};
        this.startDragParentEntity = null;
    }
    onAdd(entity, newComponent) {
        if (!this.isEnabled)
            return;
        this.onDragEntityChanged(newComponent.entity);
        this.oldDraggedEntity = newComponent.entity;
        this.startDragParentEntity = this.coreApi.entities.getAssemblyRoot(newComponent.entity);
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (!this.isEnabled)
            return;
        this.onDragEntityChanged(newComponent.entity);
    }
    onRemove(entity, oldComponent) {
        if (!this.isEnabled)
            return;
        const dragStartedOrEndedInCornerSolution = this.dragStartOrEndedInCornerSolution(oldComponent);
        if (this.oldDraggedEntity !== oldComponent.entity || dragStartedOrEndedInCornerSolution) {
            this.onDragEntityStopped(oldComponent.entity);
        }
    }
    onDragEntityChanged(entity) {
        const box = this.coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_DRAWER_BOX_ASM);
        const mat = this.coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_DRAWER_MAT);
        const skubbCase = this.coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_SKUBB_STORAGE_CASES);
        if (box !== null || mat !== null || skubbCase !== null) {
            this.dragAffectingAccessories = true;
            this.boxVariant = box?.getComponent(ComponentIds.AUTO_ADAPT_GUEST_COMPONENT_ID)?.variants[0];
            this.matVariant = mat?.getComponent(ComponentIds.AUTO_ADAPT_GUEST_COMPONENT_ID)?.variants[0];
            this.skubbVariant = skubbCase?.getComponent(ComponentIds.AUTO_ADAPT_GUEST_COMPONENT_ID)?.variants[0];
        }
    }
    onDragEntityStopped(entity) {
        if (!this.dragAffectingAccessories) {
            return;
        }
        const isPullOutTray = this.coreApi.entities.isOneOfProductTypes(entity, [
            ProductType.PAX_PULL_OUT_TRAY,
            ProductType.PAX_PULL_OUT_TRAY_WITH_DIVIDER_INSERTS_ASM,
            ProductType.PAX_PULL_OUT_TRAY_WITH_COMPARTMENT_INSERTS_ASM,
            ProductType.PAX_PULL_OUT_TRAY_WITH_SHOE_INSERTS_ASM,
            ProductType.PAX_PULL_OUT_TRAY_INSERT,
            ProductType.PAX_PULL_OUT_TRAY_WITH_MAT_ASM
        ]);
        if (isPullOutTray) {
            return;
        }
        const currentDrawerBox = this.coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_DRAWER_BOX_ASM);
        if (currentDrawerBox) {
            this.coreApi.entities.delete(currentDrawerBox);
        }
        const currentDrawerMat = this.coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_DRAWER_MAT);
        if (currentDrawerMat) {
            this.coreApi.entities.delete(currentDrawerMat);
        }
        if (this.boxVariant !== undefined) {
            this.addAccessory(this.boxVariant, entity);
        }
        if (this.matVariant !== undefined) {
            this.addAccessory(this.matVariant, entity);
        }
        this.handleSkubbDragStopped(entity);
        this.dragAffectingAccessories = false;
        this.boxVariant = undefined;
        this.matVariant = undefined;
        this.startDragParentEntity = null;
    }
    addAccessory(variant, entity) {
        this.coreApi.products.addToTarget(variant, entity);
    }
    dragStartOrEndedInCornerSolution(oldComponent) {
        const endDragAssemblyRoot = this.coreApi.entities.getAssemblyRoot(oldComponent.entity);
        return ((this.startDragParentEntity &&
            this.coreApi.entities.getProductType(this.startDragParentEntity) ===
                ProductType.PAX_CORNER_SOLUTION_ASM) ||
            (endDragAssemblyRoot &&
                this.coreApi.entities.getProductType(endDragAssemblyRoot) ===
                    ProductType.PAX_CORNER_SOLUTION_ASM));
    }
    handleSkubbDragStopped(entity) {
        const currentSkubbCase = this.coreApi.entities.findDescendantWithProductType(entity, ProductType.PAX_SKUBB_STORAGE_CASES);
        if (currentSkubbCase) {
            this.coreApi.entities.delete(currentSkubbCase);
        }
        if (this.skubbVariant !== undefined) {
            this.addAccessory(this.skubbVariant, entity);
        }
        this.skubbVariant = undefined;
    }
}
//# sourceMappingURL=AutoAdaptAccessoriesSystem.js.map